/**
 * Утилита для приведения типа File к типу Blob
 *
 * @param {File} file
 */
export const convertFileToBlob = (file: File): Blob => {
  return new Blob([file], { type: file.type });
};
